/**
 * Layout constants
 */

const SectionLayout = {
    DEFAULT: 'default',
    FRIDAY: 'friday',
    LEMATIN: 'lematin',
    CAROUSEL: 'carousel',
    CAROUSEL_VIDEO_SERIES: 'videoSeries',
    RELATED_CONTENT: 'relatedContent',
    SUB_NAVIGATION: 'subnavigation',
    EDITORIAL_PICK: 'editorialPick',
    LIFESTYLE: 'lifestyle'
};

export {SectionLayout};
